import {
  LayoutDashboard,
  Users,
  BarChart3,
  Plug,
  MessageSquare,
  User as UserIcon,
  Shield,
  Star,
  BookOpen,
  LogOut,
  CreditCard,
  Building2,
} from "lucide-react";

const navigation = [
  { name: "Dashboard", href: "/", icon: LayoutDashboard },
  { name: "My Subscription", href: "suscriptions", icon: CreditCard },
  { name: "User Management", href: "users", icon: Users },
  { name: "User Roles", href: "user-roles", icon: Star },
  { name: "Knowledge Bases", href: "knowledge-bases", icon: BookOpen },
  { name: "Access Tools Permissions", href: "access-tools-permissions", icon: Shield },
  { name: "Usage", href: "usage", icon: BarChart3 },
  { name: "Integrations", href: "integrations", icon: Plug },
  { name: "My Profile", href: "profile", icon: UserIcon },
  { name: "Organization", href: "organization", icon: Building2 },
  { name: "Chat with Owly", href: "chat", icon: MessageSquare },
  { name: "Logout", type: "logout", icon: LogOut },
];

export default navigation;
